import React from 'react'
import DatePicker from 'react-datepicker'

import './styles.scss'

export const MonthYearDropDown = ({ selectedDate, onChangeSelectedDate }) => {
    return (
        <div className="datepicker-label-container">
            <div>
                <label className="dropdown-label">Month & Year: &nbsp;</label>
            </div>
            <div>
                <DatePicker
                    gridID={"MonthYearDropdown"}
                    selected={selectedDate}
                    onChange={(date) => onChangeSelectedDate(date)}
                    dateFormat="MMM-yyyy"
                    showMonthYearPicker
                />
            </div>
        </div>

    )
}